/**
 * Shared planner Task Manager / action copy.
 *
 * Keep in sync with backend ``apps.product.constant.REFRESH_PROJECTIONS_TASK_TITLE``.
 *
 * @const {string}
 */
export const REFRESH_PROJECTIONS_TASK_TITLE = "Refreshing Requirements";

/**
 * Notification type for the ~30 minute scheduled planning-run heads-up.
 *
 * Keep in sync with backend ``PLANNING_RUN_ADVANCE_WARNING_CODE``.
 *
 * @const {string}
 */
export const PLANNING_RUN_ADVANCE_WARNING_CODE = "PLANNING-RUN_ADVANCE_WARNING";
